import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { tc } from '../../lib/trackingContext';
import { useOrderSummary, OrderSummary } from '../useOrderSummary';

export const useSecondPaymentCompletedTracking = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderItems } = useOrderSummary(orderNumber);

  const trackSecondPaymentCompleted = useCallback(
    (order?: OrderSummary) => {
      tc.track('Second Payment Completed', {
        addToScopeOnce: {
          order,
          products: orderItems
        }
      });
    },
    [orderItems]
  );

  return { trackSecondPaymentCompleted };
};
